// Where the command bar sits when a board gives it a place of its own: a doc board's page panel holds it at its
// top, above the writing (David, 16 Oct). Elsewhere it rests at the bottom of the screen.

import { create } from "zustand";

export const useBarSlot = create<{ el: HTMLElement | null }>(() => ({ el: null }));
